import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/traversal/has/has.js";

export default obj => {
	$("button[type=submit]:not([data-download]),input[type=submit]:not([data-download])", obj).on("click", function (e) {
		const input = obj.has(this).find("label[for]").attr("for");
		if (input) {
			$("#" + input).prop("checked", false);
		}
	});
};
